<div class="migrated-user-prompt-popup-container">
  <app-loading *ngIf="isLoading" />
  <div class="migrated-user-prompt-popup-container__image">
    <img src="assets/images/svg/not-found.svg" alt="" width="80" />
  </div>
  <h1 class="migrated-user-prompt-popup-container__title">
    {{ title | translate }}
  </h1>
  <p
    class="migrated-user-prompt-popup-container__content"
    [innerHTML]="promptContent | translate: { loginHint: loginHintHtml, mailTo: mailToLink }"
  ></p>
  <app-button class="migrated-user-prompt-popup-container__button" [label]="getButtonLabel() | translate" (click)="handleClick()" />
</div>
